import { all } from 'redux-saga/effects';
import tableManagementGroupSaga from './group';
import tableManagementMapSaga from './map';
import tableManagementReportSaga from './report';
import tableManagementSubscriptionSaga from './tableManagementSubscription';
import tableManagementVoidItemSaga from './voidItem';

export default function* tableManagementSaga() {
  yield all([
    tableManagementGroupSaga(),
    tableManagementMapSaga(),
    tableManagementReportSaga(),
    tableManagementSubscriptionSaga(),
    tableManagementVoidItemSaga(),
  ]);
}
